import GameCard from '../../../components/GameCard'
import { SCORING_EXAMPLES } from '../scoringExamples'
import DemoFrame from './DemoFrame'
import { demoGame, demoNoop } from './demoFixtures'

/**
 * The whole scoring explanation: four real `GameCard`s, one per band a resolved
 * fixture can land in, each carrying its predicted line, the actual line and its points. The
 * differences are visible without reading, which is the only reason the section needs no `points`.
 *
 * The four modifiers are deliberately absent. Banker, Double Up, Goalfest and Clean Sweep each own
 * their own section; this one explains the base award.
 *
 * `alive` runs the cards as the app runs them, exact card's glints, dust and idle sparks included.
 * The rules page stays frozen — a section explaining scoring wants a picture, not a light show —
 * but the release notice announcing those effects has to actually show them.
 */
export default function ScoringDemo({ alive = false }: { alive?: boolean }) {
  return (
    <DemoFrame className="rules-demo--scoring">
      {SCORING_EXAMPLES.map((example) => (
        <GameCard
          key={example.key}
          demo={!alive}
          game={demoGame(example.key, example.homeTeam, example.awayTeam)}
          prediction={{ gameId: example.key, ...example.predicted }}
          actualResult={example.actual}
          onClick={demoNoop}
          isBanker={false}
          isDoubleUpActive={false}
          isCleanSweepActive={false}
          deadlinePassed
        />
      ))}
    </DemoFrame>
  )
}
